var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef, Renderer } from '@angular/core';
var BtnColorDirective = /** @class */ (function () {
    function BtnColorDirective(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.setColor();
    }
    BtnColorDirective.prototype.setColor = function () {
        var button_color = '#ffffff';
        var button_background = '#4e8ef7';
        if (localStorage.getItem('base_data') && localStorage.getItem('base_data') != '') {
            var base_data = JSON.parse(localStorage.getItem('base_data'));
            if (base_data['button_color']) {
                button_color = base_data['button_color'];
            }
            if (base_data['button_background_color']) {
                button_background = base_data['button_background_color'];
            }
        }
        this.renderer.setElementStyle(this.el.nativeElement, 'color', button_color);
        this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', button_background);
    };
    BtnColorDirective = __decorate([
        Directive({
            selector: '[btn-color]'
        }),
        __metadata("design:paramtypes", [ElementRef,
            Renderer])
    ], BtnColorDirective);
    return BtnColorDirective;
}());
export { BtnColorDirective };
//# sourceMappingURL=btn-color.js.map


// WEBPACK FOOTER //
// ./src/directives/btn-color/btn-color.ts.pre-build-optimizer.js